import { CPEAPIClient } from '@shared/api';

interface StageHandler {
  validate: (claimId: string) => Promise<boolean>;
  sideEffects?: (claimId: string) => Promise<void>;
}

interface StageHandlers {
  [key: string]: StageHandler;
}

// Stage-specific validation and side effects
export const stageHandlers: StageHandlers = {
  Estimado: {
    validate: async () => true, // No pre-validation needed

    sideEffects: async (claimId: string) => {
      await CPEAPIClient.post(
        `/v1/claims/${claimId}/complete-stage/estimation`,
      );
    },
  },
  Auditoría: {
    validate: async (claimId: string) => {
      const claimFlagsResponse = await CPEAPIClient.get(
        `/v1/claims/${claimId}/flags`,
      );
      const claimFlags = claimFlagsResponse.data;

      const blockingFlags = claimFlags.filter(
        (flag) => flag.category === 'BLOCKING' && flag.status === 'created',
      );

      if (blockingFlags.length > 0) {
        const flagDescriptions = blockingFlags
          .map((flag) => flag.description)
          .join('</li><li>');

        const errorMessage = `
          <div style="text-align: left; font-family: Connect, Arial, sans-serif;">
            <div style="font-size: 16px; color: #333; margin-bottom: 16px;">
              The following blocking issues need to be resolved:
            </div>
            <ul style="
              list-style-type: none; 
              margin: 0;
              padding: 0 0 0 16px;
              color: #555;
              font-size: 15px;
              line-height: 1.6;
            ">
              <li>${flagDescriptions}</li>
            </ul>
            <div style="margin-top: 16px; font-size: 14px; color: #666;">
              Please resolve these issues before proceeding.
            </div>
          </div>
        `;

        throw new Error(errorMessage);
      }

      return true;
    },
    sideEffects: async (claimId: string) => {
      await CPEAPIClient.post(`/v1/claims/${claimId}/complete-stage/audit`);
    },
  },
  'Procesado Aseguradora': {
    validate: async () => true, // No pre-validation needed
    sideEffects: async (claimId: string) => {
      await CPEAPIClient.post(
        `/v1/claims/${claimId}/complete-stage/insurer_approval`,
      );
    },
  },
};

export const runDefaultBehavior = (setters: {
  initOptionStep: () => void;
  setReasonStatusChange: (value: string) => void;
  setTextNotification: (value: string) => void;
  setStatusSelected: (value: any) => void;
  setIsDisabledButtonConfirm: (value: boolean) => void;
  setShowConfirmSubmit: (value: boolean) => void;
}) => {
  const {
    initOptionStep,
    setReasonStatusChange,
    setTextNotification,
    setStatusSelected,
    setIsDisabledButtonConfirm,
    setShowConfirmSubmit,
  } = setters;

  initOptionStep();
  setReasonStatusChange('');
  setTextNotification('');
  setStatusSelected(undefined);
  setIsDisabledButtonConfirm(false);
  setShowConfirmSubmit(true);
};
